var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7133 17.902L19.4813 16.134L21.2483 17.902C21.598 18.2516 21.8362 18.6971 21.9327 19.182C22.0292 19.667 21.9798 20.1697 21.7906 20.6266C21.6014 21.0834 21.2809 21.4739 20.8698 21.7487C20.4587 22.0234 19.9753 22.17 19.4808 22.17C18.9863 22.17 18.5029 22.0234 18.0918 21.7487C17.6806 21.4739 17.3602 21.0834 17.171 20.6266C16.9818 20.1697 16.9324 19.667 17.0289 19.182C17.1254 18.6971 17.3636 18.2516 17.7133 17.902ZM7.36329 0.25L18.6773 11.563C18.7703 11.6559 18.844 11.7662 18.8943 11.8876C18.9447 12.009 18.9706 12.1391 18.9706 12.2705C18.9706 12.4019 18.9447 12.532 18.8943 12.6534C18.844 12.7748 18.7703 12.8851 18.6773 12.978L10.1923 21.463C10.0048 21.6505 9.75045 21.7558 9.48529 21.7558C9.22012 21.7558 8.96581 21.6505 8.77829 21.463L0.293287 12.978C0.20031 12.8851 0.126551 12.7748 0.0762269 12.6534C0.0259027 12.532 0 12.4019 0 12.2705C0 12.1391 0.0259027 12.009 0.0762269 11.8876C0.126551 11.7662 0.20031 11.6559 0.293287 11.563L8.07129 3.785L5.94929 1.664L7.36529 0.25H7.36329ZM9.48529 5.2L2.41429 12.27H16.5553L9.48529 5.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon02);
export default __webpack_public_path__ + "static/media/sidebar-icon-02.e22cec1794a92c65d17220a417095c3f.svg";
export { ForwardRef as ReactComponent };